var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"0"}},[_c('navbar'),_c('pageHowto')],1)}
var staticRenderFns = []

export { render, staticRenderFns }